import { _toUnsigned } from './../utils';
export class _InBuffer {
    constructor() {
        this._bBuffer = 0;
        this._bInBuffer = 0;
        this._begin = 0;
        this._end = 0;
    }
    get _bytes() {
        return (this._end - this._begin) + Math.floor(this._bInBuffer / 8);
    }
    _needsInput() {
        return this._begin === this._end;
    }
    _availableBits(count) {
        if (this._bInBuffer < count) {
            if (this._needsInput()) {
                return false;
            }
            this._bBuffer |= _toUnsigned(this._buffer[this._begin++], 32) << this._bInBuffer;
            this._bInBuffer += 8;
            if (this._bInBuffer < count) {
                if (this._needsInput()) {
                    return false;
                }
                this._bBuffer |= _toUnsigned(this._buffer[this._begin++], 32) << this._bInBuffer;
                this._bInBuffer += 8;
            }
        }
        return true;
    }
    _load16Bits() {
        if (this._bInBuffer < 8) {
            if (this._begin < this._end) {
                this._bBuffer |= _toUnsigned(this._buffer[this._begin++], 32) << this._bInBuffer;
                this._bInBuffer += 8;
            }
            if (this._begin < this._end) {
                this._bBuffer |= _toUnsigned(this._buffer[this._begin++], 32) << this._bInBuffer;
                this._bInBuffer += 8;
            }
        }
        else if (this._bInBuffer < 16) {
            if (this._begin < this._end) {
                this._bBuffer |= _toUnsigned(this._buffer[this._begin++], 32) << this._bInBuffer;
                this._bInBuffer += 8;
            }
        }
        return this._bBuffer;
    }
    _getBitMask(count) {
        return (_toUnsigned(1, 32) << count) - 1;
    }
    _getBits(count) {
        if (!this._availableBits(count)) {
            return -1;
        }
        const result = this._bBuffer & this._getBitMask(count);
        this._bBuffer >>= count;
        this._bInBuffer -= count;
        return result;
    }
    _copyTo(output, offset, length) {
        let bitBuffer = 0;
        while (this._bInBuffer > 0 && length > 0) {
            output[offset++] = _toUnsigned(this._bBuffer, 8);
            this._bBuffer >>= 8;
            this._bInBuffer -= 8;
            length--;
            bitBuffer++;
        }
        if (length === 0) {
            return bitBuffer;
        }
        const avail = this._end - this._begin;
        if (length > avail) {
            length = avail;
        }
        for (let i = 0; i < length && i + this._begin < this._buffer.length && i + offset < output.length; i++) {
            output[offset + i] = this._buffer[this._begin + i];
        }
        this._begin += length;
        return bitBuffer + length;
    }
    _setInput(buffer, offset, length) {
        this._buffer = buffer;
        this._begin = offset;
        this._end = offset + length;
    }
    _skipBits(n) {
        this._bBuffer >>= n;
        this._bInBuffer -= n;
    }
    _skipByteBoundary() {
        this._bBuffer >>= this._bInBuffer % 8;
        this._bInBuffer = this._bInBuffer - (this._bInBuffer % 8);
    }
}
